import { useKeybanNft } from "~/nft";
import { usePromise } from "~/promise";
import { useKeybanClient } from "~/provider";

/**
 * Retrives a single DPP.
 * @param collectionId - The identifier of the collection
 * @param dppId - The ID of the DPP
 * @returns - The result containing the DPP or an error.
 */
export function useKeybanDpp(collectionId: string, dppId: string) {
  const client = useKeybanClient();
  const key = ["dpp", collectionId, dppId].join(":");

  const [tokenAddress, tokenAddressError] = usePromise(
    `dpp:collection:${collectionId}`,
    () =>
      client.api.dpp
        .getCollection(collectionId)
        .then((collection) => collection.address),
  );

  const [tokenId, tokenIdError] = usePromise(
    key,
    async () => {
      const buf = await crypto.subtle.digest(
        "SHA-256",
        new TextEncoder().encode(key),
      );

      const h = "0123456789ABCDEF".toLowerCase();
      const hex = [...new Uint8Array(buf)]
        .flatMap((v) => h[v >> 4] + h[v & 15])
        .join("");

      return BigInt(`0x${hex}`).toString();
    },
    { suspense: true },
  );

  const [nft, nftError] = useKeybanNft(tokenAddress ?? "", tokenId ?? "");

  return [nft, tokenAddressError ?? tokenIdError ?? nftError] as const;
}
